import React from 'react';

import DialogCategory from './DialogCategory';
import DialogBanner from './DialogBanner';
import DialogItem from './DialogItem';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const stylesBt = theme => ({
    button: {
        margin: theme.spacing.unit,
        position: 'fixed',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
});

class CreateButton extends React.Component {
    state = {
        open: false
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    };

    handleClose = value => {
        this.setState({ open: false });
    };

    render() {
        const { classes, item } = this.props;
        //console.log(item);
        return (
            <div>
                {this.state.open ? (this.props.type=="Category"?<DialogCategory
                    item={item}
                    fullScreen={true}
                    open={this.state.open}
                    onClose={this.handleClose}
                />:
                this.props.type=="Banner"?<DialogBanner
                    item={item}
                    fullScreen={true}
                    open={this.state.open}
                    onClose={this.handleClose}
                />:
                this.props.type=="Item"?<DialogItem
                    item={item}
                    cats={this.props.cats}
                    fullScreen={true}
                    open={this.state.open}
                    onClose={this.handleClose}
                />:"") :
                    <Button onClick={this.handleClickOpen} variant="fab" color="secondary" aria-label="add" className={classes.button}>
                        <AddIcon />
                    </Button>}

            </div>
        );
    }
}

CreateButton.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(stylesBt)(CreateButton);
